<template>
  <PageContainer title="Aulas Práticas">
    <div slot="header">
      <Button type="button" @handle:click="openModalUploadAula" text="Upload de aula" color="secondary"
        :disabled="loading">
        <CloudUploadOutline :size="18" />
      </Button>
    </div>

    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <Box space="medium" v-else-if="aulaEditar.id == null" class="praticas-container">
      <form @submit.prevent="handleSubmit" class="main-form">
        <div class="inputs">
          <div class="inputs-row">
            <Select class="input-full" :options="schemaOptions" legend="Autoescola"
              placeholder="Selecione uma autoescola" :modelValue="schema"
              @update:modelValue="$event => schema = $event" />

            <Period legend="Data" :firstModelValue="initialDate" :secondModelValue="finalDate"
              @update:firstModelValue="$event => (initialDate = $event)"
              @update:secondModelValue="$event => (finalDate = $event)" :disabled="loading" />

            <Select class="input-full" :options="orderOptions" legend="Ordenar por" placeholder="Selecione a ordenação"
              :modelValue="order" @update:modelValue="$event => order = $event" />
          </div>

          <div class="inputs-row">
            <Select class="input-full" :options="categoriaOptions" legend="Categoria"
              placeholder="Selecione uma categoria" :modelValue="categoria"
              @update:modelValue="$event => categoria = $event" />

            <Input class="input-full" legend="Nome do aluno" placeholder="Digite o nome do aluno" :modelValue="aluno"
              @update:modelValue="$event => aluno = $event" />

            <Input class="input-full" legend="Nome do instrutor" placeholder="Digite o nome do instrutor"
              :modelValue="instrutor" @update:modelValue="$event => instrutor = $event" />
          </div>
        </div>

        <div class="buttons">
          <Button type="button" @handle:click="clearInputs" text="Limpar" :fill="false" color="danger"
            :disabled="loading">
            <CloseCircleOutline :size="18" />
          </Button>

          <Button type="submit" text="Consultar" color="primary" :disabled="loading">
            <Magnify :size="18" />
          </Button>
        </div>
      </form>

      <div class="loading" v-if="loading">
        <LoadingSpinner />
      </div>

      <div class="table-container" v-else-if="aulas.length > 0">
        <div class="summary">
          <Input class="input-full" legend="Resultado" :modelValue="paginationData.total" readonly />
          <Input class="input-full" legend="Total aceitas" :modelValue="aceitas" readonly />
          <Input class="input-full" legend="Aceitas por página" :modelValue="aceitasPorPagina" readonly />
        </div>

        <div class="table-header">
          <StatusLegend :statusOptions="statusLegendOptions" />

          <Paginate :total-pages="paginationData.lastPage" :current-page="paginationData.currentPage"
            @page-changed="fetchAulas" />
        </div>

        <Table
          :headers="['#', 'Nome', 'Instrutor', 'Veículo', 'Categoria', 'Observação', 'Anotação', 'Status', 'Data / Horário', 'Ações']">
          <tr v-for="(aula, index) in aulas" :key="aula.id">
            <td>
              <BadgeCircle v-if="!aula.cancelada" color="green" />
              <BadgeCircle v-else color="red" />
            </td>
            <td>{{ aula.nome }}</td>
            <td>{{ aula.instrutor }}</td>
            <td>{{ aula.placaVeiculo }}</td>
            <td>{{ aula.categoria }}</td>
            <td :title="aula.cancelada_por ? aula.cancelada_por : '-'">
              <span>{{ aula.observacao ? aula.observacao : '-' }}</span>
            </td>
            <td>{{ aula.anotacaoPratica || '-' }}</td>
            <td>{{ aula.status || '-' }}</td>
            <td>{{ utils.formatDate(aula.data) }}</td>
            <td>
              <div class="actions" v-if="idRole == 9">
                <div v-if="aula.anotacaoPratica">
                  <IconButton @handle:click="newCurrentIndex(index, aula)" color="primary" title="Detalhes"
                    :disabled="loadingActions">
                    <EyeOutline :size="19" />
                  </IconButton>
                </div>

                <div v-if="aula.anotacaoPratica">
                  <IconButton @handle:click="gerarRelatorio(schema, aula.id)" color="secondary" title="Relatório"
                    :disabled="loadingActions">
                    <FileOutline :size="19" />
                  </IconButton>
                </div>
              </div>

              <div v-else class="actions">
                <div
                  v-if="aula.anotacaoPratica === null && ['filipe_monitoramento@fabricainfo.com', 'nadlo.cavalcante@fabricainfo.com', 'jvdsantos@teste.com', 'nicole@monitoramento.com', 'joselevi514@gmail.com', 'brenda.tavares@financeiro.com', 'wylder@monitoramento.com'].includes(email)">
                  <IconButton @handle:click="openCriarAnotacaoModal(aula)" color="primary" title="Criar anotação"
                    :disabled="loadingActions">
                    <AccountPlusOutline :size="19" />
                  </IconButton>
                </div>

                <div v-if="!aula.status">
                  <IconButton @handle:click="showAula(aula)" color="secondary" title="Visualizar e Editar"
                    :disabled="loadingActions">
                    <PencilOutline :size="19" />
                  </IconButton>
                </div>

                <div v-if="aula.anotacaoPratica">
                  <IconButton @handle:click="newCurrentIndex(index, aula)" color="success" title="Visualizar fotos"
                    :disabled="loadingActions">
                    <EyeOutline :size="19" />
                  </IconButton>
                </div>

                <div v-if="aula.anotacaoPratica">
                  <IconButton @handle:click="gerarRelatorio(schema, aula.id)" color="primary" title="Relatório"
                    :disabled="loadingActions">
                    <FileOutline :size="19" />
                  </IconButton>
                </div>

                <div v-if="aula.cancelada !== true">
                  <IconButton @handle:click="actionModalCancel(aula)" color="danger" title="Cancelar aula"
                    :disabled="loadingActions">
                    <Close :size="19" />
                  </IconButton>
                </div>

                <div v-if="aula.cancelada !== true && aula.anotacaoPratica != null">
                  <IconButton @handle:click="deleteAnnotation(aula)" color="danger" title="Cancelar aula realizada"
                    :disabled="loadingActions">
                    <Eraser :size="19" />
                  </IconButton>
                </div>
              </div>
            </td>
          </tr>
        </Table>
      </div>
    </Box>

    <div id="ListarAulasPraticas">
      <div class="modal-backdrop fade d-none" ref="modalBackdrop"></div>
      <transition @enter="toggleModalElement" @after-enter="toggleModalBackDrop" @before-leave="toggleModalBackDrop"
        @after-leave="toggleModalElement">
        <aula-modal v-if="aulaModal.show" :aula="aulaModal.aula" :instrutores="aulaModal.instrutores"
          :veiculos="aulaModal.veiculos" @close="closeModalAluno()" />
      </transition>

      <!-- MODAL DELETAR IMAGEM -->
      <div id="modalImageDelete" v-if="showModalImageDelete">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-header">
                  <slot name="header">
                    <h3>Confirmar</h3>
                  </slot>
                </div>

                <div class="modal-body">
                  <slot name="body">
                    Deseja realmente deletar essa foto?
                  </slot>
                </div>

                <div class="modal-footer">
                  <slot name="footer">
                    <button class="modal-default-button btn btn-danger btn-micro" @click="actionModalImageDelete()">
                      Não
                    </button>
                    <button class="modal-default-button btn btn-success btn-micro" @click="noDetectImage(aula)">
                      Sim
                    </button>
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <!-- MODAL CANCELAR -->
      <div id="modalCancel" v-if="showModalCancel">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-header">
                  <slot name="header">
                    <h3>Confirmar</h3>
                  </slot>
                </div>

                <div class="modal-body">
                  <slot name="body">
                    Deseja realmente cancelar essa aula?
                  </slot>
                </div>

                <div class="modal-footer">
                  <slot name="footer">
                    <button class="modal-default-button btn btn-danger btn-micro" @click="actionModalCancel()">
                      Não
                    </button>
                    <button class="modal-default-button btn btn-success btn-micro" @click="cancelAula(aula)">
                      Sim
                    </button>
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <!-- MODAL AULAS - FOTOS -->
      <vuestic-modal :show.sync="show" v-bind:large="true" ref="largeModal" id="modalPhotos">
        <div slot="title">Fotos - Aulas Práticas</div>
        <div v-if="loadFoto" class="d-flex justify-content-center">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
          </component>
        </div>
        <div v-else class="row">
          <div class="col-md-12 mb-3 d-flex">
            <div class="col-md-3">
              <strong class="font-weight-bold">Aluno</strong>
              <span style="overflow: hidden;" class="input-group-text mt-2">{{ aulaSelected.nome }}</span>
            </div>
            <div class="col-md-3">
              <strong class="font-weight-bold">Instrutor</strong>
              <span style="overflow: hidden;" class="input-group-text mt-2">{{ aulaSelected.instrutor }}</span>
            </div>
            <div class="col-md-3">
              <strong class="font-weight-bold">Início da Aula (Previsto)</strong>
              <span style="overflow: hidden;" class="input-group-text mt-2">{{ aulaSelected.data }}</span>
            </div>
            <div class="col-md-3">
              <strong class="font-weight-bold">Fim da Aula (Previsto)</strong>
              <span style="overflow: hidden;" class="input-group-text mt-2">{{ aulaSelected.hora_fim }}</span>
            </div>
          </div>
          <div v-if="fotos.length === 0 && !biometriasInstrutor.length && !biometriasAluno.length"
            class="col-md-12 mt-3">
            <div style="min-height: 100px" class="col-md-12 mt-3 text-center">
              Nenhum registro de imagens encontrado!
            </div>
          </div>
          <div v-else class="col-md-12 d-flex">
            <div class="col-md-7 mt-3">
              <div style="max-height: 600px; overflow: auto">
                <template>
                  <div class="fotos-section">
                    <strong class="font-weight-bold ">Instrutor</strong>

                    <div>
                      <span v-if="biometriasInstrutor.length < 1">Sem fotos de biometria</span>
                      <span v-else class="mr-1 ml-1 text-center" v-for="(foto, Index) in biometriasInstrutor"
                        :key="Index">
                        <img :id="foto.idFoto" class="img-thumbnail mt-2 mb-2"
                          style="width: 160px; height: 160px; cursor: pointer" @click="imgSelected = foto"
                          :src="loadImage(foto.base64)" alt="">
                      </span>
                    </div>
                  </div>

                  <div class="fotos-section">
                    <strong class="font-weight-bold ">Aluno</strong>

                    <div>
                      <span v-if="biometriasAluno.length < 1">Sem fotos de biometria</span>
                      <span v-else class="mr-1 ml-1 text-center" v-for="(foto, Index) in biometriasAluno" :key="Index">
                        <img :id="foto.idFoto" class="img-thumbnail mt-2 mb-2"
                          style="width: 160px; height: 160px; cursor: pointer" @click="imgSelected = foto"
                          :src="loadImage(foto.base64)" alt="">
                      </span>
                    </div>
                  </div>

                  <div class="fotos-section">
                    <strong class="font-weight-bold ">Capturas Aleatórias</strong>

                    <div>
                      <span v-if="fotos.length < 1">Sem fotos de captura aleatórias</span>
                      <span v-else class="mr-1 ml-1 text-center" v-for="(foto, Index) in fotos" :key="Index">
                        <img :id="foto.idFoto" class="img-thumbnail mt-2 mb-2"
                          style="width: 160px; height: 160px; cursor: pointer" @click="imgSelected = foto"
                          :src="loadImage(foto.base64)" alt="">
                      </span>
                    </div>
                  </div>
                </template>
              </div>
              <div style="display: flex" class="mt-3">
                <div class="col-md-6">
                </div>
                <div class="col-md-6 text-right">
                  <span class="badge bg-secondary">{{ fotos.length }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-5 text-center">
              <span>
                <img v-if="imgSelected" class="img-thumbnail mt-2 mb-2" style="width: auto; height: 400px"
                  :src="loadImage(imgSelected.base64)" alt="">
              </span>
              <div id="acoes" class="mt-3">
                <!-- IMAGEM COM ERRO -->
                <span class="ml-2 mr-2">
                  <a @click="actionModalImageDelete()">
                    <i title="Nada detectado" class="fa fa-low-vision"></i>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>

        <a class="prev" @click="prev(aula)" href="#">&#10094; Anterior</a>
        <a class="next" @click="next(aula)" href="#">&#10095; Próximo</a>
      </vuestic-modal>

      <CriarAnotacaoModal ref="criarAnotacaoModal" @submited="fetchAulas" />

      <!-- MODAL UPLOAD DE AULA -->
      <vuestic-modal v-if="idRole != 9" ref="uploadAulaModal" cancelClass="none" okClass="none" :large="true">
        <div slot="title">Upload de aula prática</div>
        <UploadAulaModal :autoescolas="schemaOptions"></UploadAulaModal>
      </vuestic-modal>

      <a href="#" hidden id="downloadDetalhesDaAula"></a>

      <aula-pratica v-if="aulaEditar.id != null" :id_aula="aulaEditar.id" :schema="aulaEditar.schema"
        @goBack="closeInfo()" />
      <vuestic-modal ref="aulaModalRef" :noButtons="true" :large="true" @cancel="fecharModalAula()">
        <RelatorioContestacaoAulaRealizada v-if="aulaModal.aula" :aula="aulaModal.aula"
          :autoescola="aulaModal.autoescola" />
      </vuestic-modal>
    </div>
  </PageContainer>
</template>

<script>
import BadgeCircle from 'core/BadgeCircle'
import Box from "core/Box"
import Button from "core/Button"
import IconButton from 'core/IconButton'
import Input from 'core/Input'
import LoadingSpinner from "core/LoadingSpinner"
import PageContainer from "core/PageContainer"
import Paginate from 'core/Paginate'
import Period from 'core/Period'
import Select from 'core/Select'
import StatusLegend from 'core/StatusLegend'
import Table from 'core/Table'
import AccountPlusOutline from "icons/AccountPlusOutline"
import Cached from 'icons/Cached'
import Close from "icons/Close"
import CloseCircleOutline from 'icons/CloseCircleOutline'
import CloudUploadOutline from "icons/CloudUploadOutline"
import Eraser from "icons/Eraser"
import EyeOutline from "icons/EyeOutline"
import FileOutline from "icons/FileOutline"
import ImageMultiple from "icons/ImageMultiple"
import Magnify from 'icons/Magnify'
import PencilOutline from "icons/PencilOutline"

import AulaPratica from '@/components/monitoria/aulas-praticas/aula-pratica/AulaPratica.vue'
import RelatorioContestacaoAulaRealizada from '@/components/relatorios/RelatorioContestacaoAulaRealizada.vue'
import urlApi from "@/router/urlApiV2"
import * as spinners from "epic-spinners"
import { ModelSelect } from "vue-search-select"
import utils from "../../../services/utils"
import GoogleMap from "../../google/GoogleMap"
import pagination from "../../pagination/pagination.vue"
import AulaModal from './aula-pratica/AulaModal.vue'
import AulasPraticasController from "./AulasPraticasController"
import CriarAnotacaoModal from "./CriarAnotacaoModal"
import UploadAulaModal from './FileModal/UploadAulaModal'

export default {
  name: 'ListarAulasPraticas',
  components: {
    PageContainer,
    LoadingSpinner,
    Button,
    Box,
    Select,
    Period,
    Input,
    StatusLegend,
    Paginate,
    Table,
    IconButton,
    BadgeCircle,

    Cached,
    Magnify,
    CloudUploadOutline,
    CloseCircleOutline,
    ImageMultiple,
    EyeOutline,
    FileOutline,
    AccountPlusOutline,
    PencilOutline,
    Close,
    Eraser,

    urlApi,
    ...spinners,
    pagination,
    ModelSelect,
    GoogleMap,
    AulaPratica,
    AulaModal,
    UploadAulaModal,
    RelatorioContestacaoAulaRealizada,
    CriarAnotacaoModal,
  },
  data() {
    return {
      idRole: localStorage.getItem('id_role'),
      utils,
      schema: '',
      initialDate: '',
      finalDate: '',
      order: '',
      categoria: '',
      aluno: '',
      instrutor: '',
      aceitas: 0,
      paginationData: {
        currentPage: 1,
        lastPage: 1,
        total: 0,
      },
      schemaOptions: [],
      orderOptions: [
        { value: 'candidato', text: 'Nome do aluno' },
        { value: 'instrutor', text: 'Nome do instrutor' },
        { value: 'veiculo', text: 'Veículo' },
        { value: 'categoria', text: 'Categoria' },
        { value: 'turno', text: 'Turno' },
        { value: 'status', text: 'Status' },
      ],
      categoriaOptions: [
        { value: 'A', text: 'A' },
        { value: 'B', text: 'B' },
        { value: 'C', text: 'C' },
        { value: 'D', text: 'D' },
        { value: 'E', text: 'E' },
      ],
      statusLegendOptions: [
        { legend: 'Ativa', color: 'green' },
        { legend: 'Cancelada', color: 'red' },
      ],
      aulas: [],
      loaded: false,
      loading: false,
      loadingActions: false,

      loadTable: false,
      loadFoto: false,
      toggleInstrutor: false,
      toggleNomeAluno: false,
      showModalCancel: false,
      showModalImageDelete: false,
      showModalCreateAnnotation: false,
      observacaoAnotacao: '',
      dataInicio: '',
      dataFim: '',
      nomeAluno: '',
      aula: '',
      orderSearch: '',
      countResult: 0,
      show: true,
      isMoto: false,
      biometriasAluno: [],
      biometriasInstrutor: [],
      fotos: [],
      aulaSelected: [],
      imgSelected: '',
      currentIndex: 0,
      table: {
        current_page: "",
        data: "",
        first_page_url: "",
        from: "",
        last_page: "",
        last_page_url: "",
        next_page_url: "",
        path: "",
        per_page: "",
        prev_page_url: "",
        to: "",
        total: "",
        pages: [],
        load: false,
        tp: "",
      },
      pagination: "",
      consult: "",
      aulas_praticas: [],
      aulaEditar: {
        schema: null,
        id: null
      },
      aulasAceitas: '',
      aulaModal: {
        show: false,
        aula: null,
        instrutores: null,
        veiculos: null,
      },
      aulaModalLoading: false,
      showCancelador: false,
      email: localStorage.email
    };
  },
  async created() {
    await this.fetchCfcs()

    this.loaded = true
  },
  methods: {
    async fetchCfcs() {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola`)
        .then((res) => {
          this.schemaOptions = res.body.dados.map(cfc => ({ value: cfc.tenant_schema, text: cfc.nome_fantasia }))
        })
        .catch((error) => {
          this.$toasted.show('Erro:' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async handleSubmit() {
      if (this.validateInputs()) {
        await this.fetchAulas()
      }
    },
    validateInputs() {
      if (!this.schema) {
        this.$toasted.show("Por favor, selecione uma autoescola!", {
          position: "top-right",
        })

        return false
      }

      const hasInitialDate = !!this.initialDate
      const hasFinalDate = !!this.finalDate

      if ((hasInitialDate && !hasFinalDate) || (!hasInitialDate && hasFinalDate)) {
        this.$toasted.show("Preencha as duas datas: inicial e final!", {
          position: "top-right",
        })
        return false
      }

      if (hasInitialDate && hasFinalDate) {
        const initial = new Date(this.initialDate)
        const final = new Date(this.finalDate)

        if (initial > final) {
          this.$toasted.show("A data inicial deve ser menor ou igual à data final!", {
            position: "top-right",
          })
          return false
        }
      }

      return true
    },
    async fetchAulas(page = 1) {
      this.loading = true

      const params = {
        page,
        schema: this.schema,
        periodo: [this.initialDate, this.finalDate],
        ordenar: this.order,
        nome: this.aluno,
        instrutor: this.instrutor,
        categoria: this.categoria,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/aulas/praticas/consultar/filtros`, { params })
        .then((res) => {
          const response = res.body

          if (response.dados.data.length < 1) {
            this.$toasted.show('Nenhum resultado encontrado!', {
              position: 'top-right',
            })
          }

          this.aulas = response.dados.data
          this.aceitas = response.aceitas

          this.paginationData = {
            currentPage: response.dados.current_page,
            lastPage: response.dados.last_page,
            total: response.dados.total,
          }
        })
        .catch((error) => {
          this.$toasted.show('Erro:' + error.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInputs() {
      this.schema = ''
      this.initialDate = ''
      this.finalDate = ''
      this.order = ''
      this.aluno = ''
      this.instrutor = ''
      this.categoria = ''
    },
    openModalUploadAula() {
      this.$refs.uploadAulaModal.open();
    },
    closeInfo() {
      this.aulaEditar.schema = null
      this.aulaEditar.id = null
    },
    openCriarAnotacaoModal(aula) {
      this.$refs.criarAnotacaoModal.open(aula, this.schema)
    },
    showAula(aula) {
      this.aulaEditar.schema = this.schema
      this.aulaEditar.id = aula.id
    },
    actionModalCancel(aula) {
      if (this.showModalCancel === true) {
        // FECHAR MODAL
        this.showModalCancel = false;
      } else {
        // ABRIR MODAL
        this.aula = aula.id;
        this.showModalCancel = true;
      }
    },
    cancelAula() {
      var data = {
        schema: this.schema,
        aula: this.aula
      }
      AulasPraticasController.cancelAula(data, (response) => {

        this.fetchAulas();
        this.actionModalCancel();
      });
    },
    deleteAnnotation(aula) {
      if (confirm('Deseja mesmo remover a anotação? A operação é irreversível')) {

        this.$http.post(urlApi + '/aulas/praticas/removerAnotacao', { id: aula.anotacaoPratica, schema: this.schema })
          .then(response => {
            if (response.data.success) {
              this.$toasted.show('Anotação removida', {
                icon: 'fa-info',
                position: 'top-right',
                duration: 5000,
                fullWidth: false
              })
              this.fetchAulas();
            }
          })
      }
    },
    next: function () {
      let currentId = 0;

      // VERIFICAR SE O TAMANHO DO ARRAY É IGUAL AO INDEX ATUAL
      if ((this.currentIndex + 1) === this.aulas.length) {
        this.currentIndex = this.aulas.length - 1
      } else {
        this.currentIndex += 1;
        // CHAMAR FUNÇÃO PARA CONSULTA COM NOVO ID
        currentId = this.aulas[this.currentIndex];
        this.aulaSelected = this.aulas[this.currentIndex];
        this.showModalFotos(currentId.id);
      }
    },
    prev: function () {
      let currentId = 0;

      if (this.currentIndex === 0) {
        this.currentIndex = 0;
      } else {
        this.currentIndex -= 1;
        // CHAMAR FUNÇÃO PARA CONSULTA COM NOVO ID
        currentId = this.aulas[this.currentIndex];
        this.aulaSelected = this.aulas[this.currentIndex];
        this.showModalFotos(currentId.id);
      }
    },
    newCurrentIndex(index, aula) {
      this.aulaSelected = aula;
      let currentId = 0;

      currentId = this.aulas[index];
      this.currentIndex = index;
      this.showModalFotos(currentId.id)
    },
    showModalFotos(aula) {
      // ABRIR MODAL
      this.$refs.largeModal.open();

      // CONSULTAR FOTOS DA AULA
      this.getFotos(aula);
    },
    getFotos(aula) {
      this.loadFoto = true;
      var data = { aula: aula, schema: this.schema };
      AulasPraticasController.getFotos(data, (response) => {
        this.fotos = ""
        this.imgSelected = ""
        if (response.sucesso === true) {
          this.isMoto = response.tipo_veiculo == 'moto' ? true : false
          this.biometriasInstrutor = response.dados.filter(item => item.biometria && item.entidade === 'instrutor');
          this.biometriasAluno = response.dados.filter(item => item.biometria && item.entidade === 'aluno');
          this.fotos = response.dados.filter(item => !item.biometria);
          this.imgSelected = this.biometriasAluno.length ? this.biometriasAluno[0] : this.fotos[0];
        }
        this.loadFoto = false;
      })
    },
    actionModalImageDelete() {
      if (this.showModalImageDelete === true) {
        // FECHAR MODAL
        this.showModalImageDelete = false;
      } else {
        // ABRIR MODAL
        this.showModalImageDelete = true;
      }
    },
    noDetectImage() {
      var data = {
        schema: this.schema,
        idFoto: this.imgSelected.idFoto,
        idAnotacao: this.aulaSelected.anotacaoPratica,
      };

      ListarAulasPraticasController.deletePhoto(data, (response) => {
        this.getFotos(this.imgSelected.idAula);
      })

      this.actionModalImageDelete();
    },
    launchToast(mensagem) {
      this.$toasted.show(mensagem, {
        position: "top-right",
      });
    },
    gerarRelatorio(autoescolaSchema, aulaId) {
      this.aulaModal = {
        autoescola: autoescolaSchema,
        aula: aulaId
      }
      // this.$refs.aulaModalRef.open();
      // router.push({ name: 'RelatorioContestacaoAulaRealizada', params: { autoescola: autoescolaSchema, aula: aulaId } })
      const routeData = this.$router.resolve({ name: 'RelatorioContestacaoAulaRealizada', params: { autoescola: autoescolaSchema, aula: aulaId } });
      window.open(routeData.href, '_blank');
    },
    fecharModalAula() {
      this.aulaModal = {}
    },
    showEditModal(schema, idAula) {
      this.aulaModalLoading = true
      this.$http.get(urlApi + '/aulas/praticas/detalhes', { params: { id: idAula, schema: schema } })
        .then(response => {
          if (response.data.success) {
            let aulaPratica = response.data.dados.aulaPratica;
            this.aulaModal.aula = {
              aulaPraticaId: aulaPratica.id_aulas_praticas,
              anotacaoPraticaId: aulaPratica.anotacao.id_anotacao_pratica,
              inicio_real: aulaPratica.anotacao.begin_time.slice(11, -3),
              fim_real: aulaPratica.anotacao.finish_time.slice(11, -3),
              hodometro_inicial: aulaPratica.anotacao.hodo_start,
              hodometro_final: aulaPratica.anotacao.hodo_end,
              alunoId: aulaPratica.id_aluno,
              aluno: aulaPratica.nomeAluno,
              renach: aulaPratica.alunoRenach,
              cpf: aulaPratica.cpfAluno,
              instrutorId: aulaPratica.id_instrutor,
              instrutor: aulaPratica.nomeInstrutor,
              categoria: aulaPratica.categoria_cnh,
              data: aulaPratica.data_aula,
              turno: aulaPratica.tipo_aula,
              veiculoId: aulaPratica.id_veiculo,
              schema: schema
            };
            this.aulaModal.instrutores = response.data.dados.instrutores.map((instrutor) => { return { id: instrutor.id_instrutor, value: instrutor.nome } });
            this.aulaModal.veiculos = response.data.dados.veiculos.map((veiculo) => { return { id: veiculo.id_veiculo, value: `${veiculo.placa} / Cat. ${veiculo.categoria_cnh}` } });
          }
          this.aulaModal.show = true;
          this.aulaModalLoading = false
        })
        .catch(() => {
          this.aulaModalLoading = false
        })
    },
    closeModalAluno() {
      this.aulaModal.show = false
    },
    toggleModalElement(el) {
      this.$refs.modalBackdrop.classList.toggle("d-block");
      el.classList.toggle("d-block");
    },
    toggleModalBackDrop(el) {
      this.$refs.modalBackdrop.classList.toggle("show");
      el.classList.toggle("show");
    },
    loadImage(base64String) {
      const byteCharacters = atob(base64String);
      const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray]);

      const mimeType = blob.type || "image/*"; // Padrão genérico se não encontrar o mime type

      const dataUrl = `data:${mimeType};base64,${base64String}`;
      return dataUrl;
    }
  },

  watch: {
    toggleInstrutor(novo, antigo) {
      // FUNCAO
      if (novo == true) {
        this.$toasted.show("Consulta Pelo Nome do Instrutor", {
          position: "top-right",
        });
        if (this.toggleNomeAluno == true) {
          this.toggleNomeAluno = false;
          document.getElementById("aluno").disabled = true;
          document.getElementById("instrutor").disabled = false;
        }
        else if (document.getElementById("instrutor").disabled == true) {
          this.toggleInstrutor = true;
          document.getElementById("instrutor").disabled = false;
        }
        else {
          document.getElementById("aluno").disabled = true;
        }
      }
      else {
        if (this.toggleNomeAluno == true) {
          this.toggleInstrutor = false;
          document.getElementById("instrutor").disabled = true;
        }
        else if (document.getElementById("aluno").disabled == true) {
          document.getElementById("aluno").disabled = false;
        }
      }
    },

    toggleNomeAluno(novo, antigo) {
      // FUNCAO
      if (novo == true) {
        this.$toasted.show("Consulta Pelo Nome do Aluno", {
          position: "top-right",
        });
        if (this.toggleInstrutor == true) {
          this.toggleInstrutor = false;
          document.getElementById("instrutor").disabled = true;
          document.getElementById("aluno").disabled = false;
        }
        else if (document.getElementById("aluno").disabled == true) {
          this.toggleNomeAluno = true;
          document.getElementById("aluno").disabled = false;
        }
        else {
          document.getElementById("instrutor").disabled = true;
        }
      }
      else {
        if (this.toggleInstrutor == true) {
          this.toggleNomeAluno = false;
          document.getElementById("aluno").disabled = true;
        }
        else if (document.getElementById("instrutor").disabled == true) {
          document.getElementById("instrutor").disabled = false;
        }
      }
    },
  },
  computed: {
    aceitasPorPagina() {
      if (this.aulas.length) {
        const count = this.aulas.filter(item => item.status === 'Aceito').length

        return count
      }

      return ''
    },
    currentClass: function () {
      return this.aulas[
        Math.abs(this.currentIndex) % this.aulas.length
      ];
    },
  },
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.praticas-container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;

  .main-form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        .input-full {
          flex: 1;
        }
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .summary {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 1.5rem;

      .input-full {
        flex: 1;
      }
    }

    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .actions {
      min-width: 5rem;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      row-gap: 0.5rem;

      div {
        padding: 0 0.5rem;
        display: flex;
        justify-content: center;

        &:not(:first-child) {
          border-left: 1px solid #ECECEC;
        }

        &:not(:last-child) {
          border-right: 1px solid #ECECEC;
        }
      }
    }
  }
}

#ListarAulasPraticas {

  // ÍCONES DE STATUS
  .fa-circle.success {
    color: #20c997;
  }

  .fa-circle.danger {
    color: #dc3545;
  }

  .fotos-section {
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;

    strong {
      font-size: 1.2rem;
    }
  }

  #aluno,
  #instrutor,
  #veiculo {
    /* Estilo iOS Checkbox */

    .switch {
      visibility: hidden;
      position: absolute;
      margin-left: -9999px;
    }

    .switch+label {
      display: inline-flex;
      position: relative;
      cursor: pointer;
      outline: none;
      user-select: none;
    }

    .switch--shadow+label {
      padding: 2px;
      width: 65px;
      height: 33.5px;
      background-color: #dddddd;
      border-radius: 30px;
      margin: 0;
    }

    .switch--shadow+label:before,
    .switch--shadow+label:after {
      display: block;
      position: absolute;
      top: 1px;
      left: 1px;
      bottom: 1px;
      content: "";
    }

    .switch--shadow+label:before {
      right: 1px;
      background-color: #f1f1f1;
      border-radius: 30px;
      transition: background 0.4s;
    }

    .switch--shadow+label:after {
      width: 33px;
      background-color: #fff;
      border-radius: 50%;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
      // transition: all 0.4s;
    }

    .switch--shadow:checked+label:before {
      background-color: #8ce196;
    }

    .switch--shadow:checked+label:after {
      transform: translateX(30px);
    }
  }

  #tabela {
    .fa {
      width: 35px;
      height: 35px;
      line-height: 15px;
      margin: 0px;
    }

    td {
      width: auto !important;
    }

    // BOTÃO VISUALIZAR E EDITAR AULA
    .fa-edit {
      color: white;
      background-color: #20c997;
      border-color: #20c997;
      padding: 10px;
      border-radius: 50%;
      box-shadow: black;
    }

    .fa-edit:hover {
      background-color: #20c9967e;
    }

    // BOTÃO VISUALIZAR FOTOS
    .fa-eye {
      color: white;
      background-color: #ffc20e;
      border-color: #ffc20e;
      padding: 10px;
      border-radius: 50%;
      box-shadow: black;
    }

    .fa-file {
      color: white;
      background-color: lightgrey;
      border-color: lightgrey;
      padding: 10px;
      border-radius: 50%;
      box-shadow: black;
    }

    .fa-eye:hover {
      background-color: #ffc30eaa;
    }

    // BOTÃO REMOVER AULA
    .fa-close {
      color: white;
      background-color: #dc3545;
      border-color: #dc3545;
      padding: 10px;
      border-radius: 50%;
      box-shadow: black;
    }

    .fa-eraser:hover {
      background-color: #dc354683;
    }

    .fa-eraser {
      color: white;
      background-color: #dc3545;
      border-color: #dc3545;
      padding: 10px;
      border-radius: 50%;
      box-shadow: black;
    }

    .fa-pencil:hover {
      background-color: #97d3c7;
    }

    .fa-pencil {
      color: white;
      background-color: #48BDA6;
      border-color: #48BDA6;
      padding: 10px;
      border-radius: 50%;
      box-shadow: black;
    }

    .fa-user-plus {
      color: white;
      background-color: #4ab2e3;
      border-color: #4ab2e3;
      padding: 10px;
      border-radius: 50%;
      box-shadow: black;
    }

    .fa-user-plus:hover {
      background-color: #4ab3e377;
    }

    // ÍCONES DE STATUS
    .fa-circle.success {
      color: #20c997;
    }

    .fa-circle.danger {
      color: #dc3545;
    }

    .fa-circle.secondary {
      color: #ced4da;
    }

    .action-button {
      all: unset;
      cursor: pointer;

      &:disabled {
        opacity: 0.5;
        cursor: wait;
      }
    }
  }

  input.form-control {
    height: 36px;
    margin-top: -3.5px;
  }

  .espacamento-oculto {
    color: transparent;
    user-select: none;
  }

  #acoes {
    .fa-user-times {
      font-size: 30px;
      color: white;
      background-color: #ff6004;
      border-color: #ff6004;
      padding: 15px 13px;
      border-radius: 180px;
      box-shadow: black;
      cursor: pointer;
    }

    .fa-user-times:hover {
      background-color: #ff60048a;
    }

    .fa-exclamation-triangle {
      font-size: 30px;
      color: white;
      background-color: #ffc20e;
      border-color: #ffc20e;
      padding: 15px 15px;
      border-radius: 50%;
      box-shadow: black;
      cursor: pointer;
    }

    .fa-exclamation-triangle:hover {
      background-color: #ffc30e79;
    }

    .fa-low-vision {
      font-size: 30px;
      color: white;
      background-color: #dc3545;
      border-color: #dc3545;
      padding: 15px 15px;
      border-radius: 50%;
      box-shadow: black;
      cursor: pointer;
    }

    .fa-low-vision:hover {
      background-color: #dc35467a;
    }

    .fa-check {
      font-size: 30px;
      color: white;
      background-color: #20c997;
      border-color: #20c997;
      padding: 15px 15px;
      border-radius: 50%;
      box-shadow: black;
      cursor: pointer;
    }

    .fa-check:hover {
      background-color: #20c99671;
    }
  }

  #modalCancel,
  #modalImageDelete,
  #modalCreateAnnotation {

    // ESTILIZAÇÃO PARA MODAL
    .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: table;
      transition: opacity 0.3s ease;
    }

    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }

    @media(min-width: 768px) {
      .modal-container {
        width: 18% !important;
        padding: 1.5% 1% !important;
      }
    }

    .modal-container {
      width: 80%;
      margin: 0px auto;
      padding: 6% 3%;
      background-color: #fff;
      border-radius: 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
      transition: all 0.3s ease;
      font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
      margin-top: 0;
      color: #34495e;
      text-align: center;
    }

    .modal-body {
      margin: 10px 0;
    }

    .modal-default-button {
      float: right;
    }

    /*
            * The following styles are auto-applied to elements with
            * transition="modal" when their visibility is toggled
            * by Vue.js.
            *
            * You can easily play with the modal transition by editing
            * these styles.
            */

    .modal-enter {
      opacity: 0;
    }

    .modal-leave-active {
      opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }

    .btn.btn-success {
      background-color: #20c997;
      border-color: #20c997;
      box-shadow: none;
    }

    .btn.btn-success:hover {
      background-color: #20c9968c;
    }
  }

  #modalPhotos {
    .badge {
      cursor: default;
      font-size: 20px;
      padding: 10px 20px;
      background-color: rgb(88, 88, 88) !important;
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: all 0.9s ease;
      overflow: hidden;
      visibility: visible;
      position: absolute;
      width: 100%;
      opacity: 1;
    }

    .fade-enter,
    .fade-leave-to {
      visibility: hidden;
      width: 100%;
      opacity: 0;
    }

    .prev,
    .next {
      cursor: pointer;
      position: absolute;
      bottom: 0%;
      width: auto;
      padding: 16px;
      color: white;
      font-weight: bold;
      font-size: 18px;
      transition: 0.7s ease;
      border-radius: 10px;
      text-decoration: none;
      user-select: none;
      background-color: rgba(0, 0, 0, 0.397);
    }

    .next {
      right: 0;
      margin-right: 0%;
    }

    .prev {
      left: 0;
      margin-left: 0%;
    }

    .prev:hover,
    .next:hover {
      background-color: rgba(0, 0, 0, 0.9);
    }

    .modal-lg div.modal-footer {
      display: none !important;
    }
  }
}
</style>
